import {
    SET_TRATAMIENTO,
    SET_SEXO,
    SET_NOMBRE_PRUEBA_DE_MANEJO,
    SET_APELLIDO_PATERNO_PRUEBA_DE_MANEJO,
    SET_ESTADO_PRUEBA_DE_MANEJO,
    SET_CIUDAD_PRUEBA_DE_MANEJO,
    SET_ID_CONCESIONARIO_PRUEBA_DE_MANEJO,
    SET_CONCESIONARIO_PRUEBA_DE_MANEJO,
    SET_TELEFONO_PRUEBA_DE_MANEJO,
    SET_MOVIL_PRUEBA_DE_MANEJO,
    SET_CORREO_PRUEBA_DE_MANEJO,
    SET_MODELO_DEL_VEHICULO_PRUEBA_DE_MANEJO,
    SET_MARCA_DEL_VEHICULO_PRUEBA_DE_MANEJO,
    SET_VEHICULO_INTERES_PRUEBA_DE_MANEJO,
    SET_COMENTARIOS_PRUEBA_DE_MANEJO,
    SET_AVISO_PRIVACIDAD_PRUEBA_DE_MANEJO,
    SET_URL_HOME_DEALER_PRUEBA_DE_MANEJO,
    RESET_STATE_PRUEBA_DE_MANEJO,
} from "../types";

/**
* Función para reiniciar el state
* @returns
*/
export function reiniciarStateAction() {
    return async (dispatch) => {
        dispatch({ type: RESET_STATE_PRUEBA_DE_MANEJO });
    };
}

/**
 *
 * @param {*} inTratamiento
 * @returns
 */
export function setTratamientoAction(inTratamiento) {
    const sexo = inTratamiento === "Sr" ? "Masculino" : "Femenino";
  
    return (dispatch) => {
      dispatch(setTratamiento(inTratamiento));
      dispatch(setSexo(sexo));
    };
  }
  const setTratamiento = (inTratamiento) => ({
    type: SET_TRATAMIENTO,
    payload: inTratamiento,
  });
  const setSexo = (inSexo) => ({
    type: SET_SEXO,
    payload: inSexo,
  });

/**
*
* @param {*} inNombre
* @returns
*/
export function setNombreAction(inNombre) {
    return (dispatch) => {
        dispatch(setNombre(inNombre));
    };
}
const setNombre = (inNombre) => ({
    type: SET_NOMBRE_PRUEBA_DE_MANEJO,
    payload: inNombre,
});

/**
 *
 * @param {*} inApellidoPaterno
 * @returns
 */
export function setApellidoPaternoAction(inApellidoPaterno) {
    return (dispatch) => {
        dispatch(setApellidoPaterno(inApellidoPaterno));
    };
}
const setApellidoPaterno = (inApellidoPaterno) => ({
    type: SET_APELLIDO_PATERNO_PRUEBA_DE_MANEJO,
    payload: inApellidoPaterno,
});

/**
 *
 * @param {*} inTelefono
 * @returns
 */
export function setTelefonoAction(inTelefono) {
    return (dispatch) => {
        dispatch(setTelefono(inTelefono));
    };
}
const setTelefono = (inTelefono) => ({
    type: SET_TELEFONO_PRUEBA_DE_MANEJO,
    payload: inTelefono,
});

/**
 *
 * @param {*} inMovil
 * @returns
 */
export function setMovilAction(inMovil) {
    return (dispatch) => {
        dispatch(setMovil(inMovil));
    };
}
const setMovil = (inMovil) => ({
    type: SET_MOVIL_PRUEBA_DE_MANEJO,
    payload: inMovil,
});

/**
 *
 * @param {*} inCorreo
 * @returns
 */
export function setCorreoAction(inCorreo) {
    return (dispatch) => {
        dispatch(setCorreo(inCorreo));
    };
}
const setCorreo = (inCorreo) => ({
    type: SET_CORREO_PRUEBA_DE_MANEJO,
    payload: inCorreo,
});

/**
 *
 * @param {*} inEstado
 * @returns
 */
export function setEstadoAction(inEstado) {
    return (dispatch) => {
        dispatch(setEstado(inEstado));
    };
}
const setEstado = (inEstado) => ({
    type: SET_ESTADO_PRUEBA_DE_MANEJO,
    payload: inEstado,
});

/**
 *
 * @param {*} inCiudad
 * @returns
 */
export function setCiudadAction(inCiudad) {
    return (dispatch) => {
        dispatch(setCiudad(inCiudad));
    };
}
const setCiudad = (inCiudad) => ({
    type: SET_CIUDAD_PRUEBA_DE_MANEJO,
    payload: inCiudad,
});

/**
 *
 * @param {*} inIdConcesionario
 * @returns
 */
export function setIdConcesionarioAction(inIdConcesionario) {
    return (dispatch) => {
        dispatch(setIdConcesionario(inIdConcesionario));
    };
}
const setIdConcesionario = (inIdConcesionario) => ({
    type: SET_ID_CONCESIONARIO_PRUEBA_DE_MANEJO,
    payload: inIdConcesionario,
});

/**
 *
 * @param {*} inConcesionario
 * @returns
 */
export function setConcesionarioAction(inConcesionario) {
    return (dispatch) => {
        dispatch(setConcesionario(inConcesionario));
    };
}
const setConcesionario = (inConcesionario) => ({
    type: SET_CONCESIONARIO_PRUEBA_DE_MANEJO,
    payload: inConcesionario,
});

/**
 *
 * @param {*} inModeloVehiculo
 * @returns
 */
export function setModeloVehiculoAction(inModeloVehiculo) {
    return (dispatch) => {
        dispatch(setModeloVehiculo(inModeloVehiculo));
    };
}
const setModeloVehiculo = (inModeloVehiculo) => ({
    type: SET_MODELO_DEL_VEHICULO_PRUEBA_DE_MANEJO,
    payload: inModeloVehiculo,
});

/**
*
* @param {*} inMarcaVehiculo
* @returns
*/
export function setMarcaVehiculoAction(inMarcaVehiculo) {
    return (dispatch) => {
        dispatch(setMarcaVehiculo(inMarcaVehiculo));
    };
}
const setMarcaVehiculo = (inMarcaVehiculo) => ({
    type: SET_MARCA_DEL_VEHICULO_PRUEBA_DE_MANEJO,
    payload: inMarcaVehiculo,
});

/**
*
* @param {*} inVehiculoInteres
* @returns
*/
export function setVehiculoInteresAction(inVehiculoInteres) {
    return (dispatch) => {
        dispatch(setVehiculoInteres(inVehiculoInteres));
    };
}
const setVehiculoInteres = (inVehiculoInteres) => ({
    type: SET_VEHICULO_INTERES_PRUEBA_DE_MANEJO,
    payload: inVehiculoInteres,
});

/**
 *
 * @param {*} inComentarios
 * @returns
 */
export function setComentariosAction(inComentarios) {
    return (dispatch) => {
        dispatch(setComentarios(inComentarios));
    };
}
const setComentarios = (inComentarios) => ({
    type: SET_COMENTARIOS_PRUEBA_DE_MANEJO,
    payload: inComentarios,
});

/**
 *
 * @param {*} inAvisosDePrivacidad
 * @returns
 */
export function setAvisosDePrivacidadAction(inAvisosDePrivacidad) {
    return (dispatch) => {
        dispatch(setAvisosDePrivacidad(inAvisosDePrivacidad));
    };
}
const setAvisosDePrivacidad = (inAvisosDePrivacidad) => ({
    type: SET_AVISO_PRIVACIDAD_PRUEBA_DE_MANEJO,
    payload: inAvisosDePrivacidad,
});;

/**
 *
 * @param {*} inUrlHomeDealer
 * @returns
 */
export function setUrlHomeDealerAction(inUrlHomeDealer) {
    return (dispatch) => {
        dispatch(setUrlHomeDealer(inUrlHomeDealer));
    };
}
const setUrlHomeDealer = (inUrlHomeDealer) => ({
    type: SET_URL_HOME_DEALER_PRUEBA_DE_MANEJO,
    payload: inUrlHomeDealer,
});